module.exports = __webpack_public_path__ + "static/img/college2.eb94a65.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college/college2.jpeg
// module id = pqcd
// module chunks = 45